import { useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { salidasApi } from '../../api/salidas'
import { fmtFecha } from '../../utils/fecha'
import { colors, font, text } from '../../design/tokens'
import { Card, Cargando, ErrorMsg, Vacio, BotonCargarMas, Titulo, TabsSegmento } from './comunes'

// Reparto móvil: salidas en calle + últimas cerradas. Solo lectura.
// Mismo criterio de resultado derivado que /logistica/distribucion e historial
// (SalidasAgrupadasPage) — mismos colores de badge que el desktop.
export function resultadoSalida(s) {
  if (s.estado === 'armando')    return { bg: colors.warnBg, color: colors.warn, label: 'Armando' }
  if (s.estado === 'despachada') return { bg: '#dbeafe', color: '#1e40af', label: 'En reparto' }
  const total = s.documentos_count || 0
  const ent   = s.entregados_count || 0
  const no    = s.no_entregados_count || 0
  const rea   = s.reagendados_count || 0
  if (total > 0 && ent === total) return { bg: colors.okBg, color: colors.ok, label: '✓ Completada' }
  if (ent === 0 && (no + rea) > 0) return { bg: colors.errBg, color: colors.err, label: '✕ No entregada' }
  if (no > 0 || rea > 0)           return { bg: '#ffedd5', color: '#9a3412', label: '◑ Parcial' }
  return { bg: colors.okBg, color: colors.ok, label: 'Cerrada' }
}

const TABS = [
  { k: 'calle',     label: 'En reparto' },
  { k: 'armando',   label: 'En armado' },
  { k: 'historial', label: 'Últimas' },
]

export default function MovilReparto() {
  const navigate = useNavigate()
  const [tab, setTab] = useState('calle')
  const [salidas, setSalidas] = useState([])
  const [pag, setPag] = useState({ current_page: 0, last_page: 1 })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const cargar = useCallback(async (page) => {
    if (page === 1) setLoading(true)
    try {
      const params = { page }
      if (tab === 'calle') params.estado = 'despachada'
      else if (tab === 'armando') params.estado = 'armando'
      else params.estado = 'cerrada'
      const { data } = await salidasApi.listar(params)
      setSalidas((prev) => (page === 1 ? data.data : [...prev, ...data.data]))
      setPag({ current_page: data.current_page, last_page: data.last_page })
      setError(null)
    } catch {
      setError('No se pudieron cargar las salidas.')
    } finally { setLoading(false) }
  }, [tab])

  useEffect(() => { cargar(1) }, [cargar])

  return (
    <div>
      <Titulo>Reparto</Titulo>

      <TabsSegmento options={TABS} value={tab} onChange={setTab} />

      {loading ? <Cargando /> : error ? <ErrorMsg>{error}</ErrorMsg> : salidas.length === 0 ? (
        <Vacio>{tab === 'calle' ? 'No hay salidas en la calle ahora.' : tab === 'armando' ? 'No hay salidas en armado.' : 'Sin salidas cerradas.'}</Vacio>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {salidas.map((s) => {
            const total = s.documentos_count || 0
            const ent = s.entregados_count || 0
            const r = resultadoSalida(s)
            return (
              <Card key={s.id} onClick={() => navigate(`/m/reparto/${s.id}`)}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontSize: 12.5, color: colors.text }}>#{s.id}</span>
                  <span style={{ flex: 1 }} />
                  <span style={{ padding: '2px 9px', borderRadius: 10, fontSize: 11, fontWeight: 600, background: r.bg, color: r.color }}>{r.label}</span>
                </div>
                <div style={{ fontFamily: font.sans, fontWeight: 600, fontSize: 14.5, color: colors.text, margin: '5px 0 6px' }}>
                  {s.fletero?.interno ? '🏬 ' : '🚚 '}{s.fletero?.nombre || 'Sin fletero'}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ flex: 1, height: 6, background: colors.borderSoft, borderRadius: 3, overflow: 'hidden' }}>
                    <div style={{ width: total ? `${(ent / total) * 100}%` : '0%', height: '100%', background: colors.progreso, borderRadius: 3 }} />
                  </div>
                  <span style={{ fontSize: text.sec, color: colors.textSec, fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>
                    {ent}/{total}
                  </span>
                  <span style={{ fontSize: text.sec, color: colors.textMeta, fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', flexShrink: 0 }}>
                    {fmtFecha(s.fecha)}
                  </span>
                </div>
              </Card>
            )
          })}
          {pag.current_page < pag.last_page && (
            <BotonCargarMas onClick={() => cargar(pag.current_page + 1)} cargando={false} />
          )}
        </div>
      )}
    </div>
  )
}
